import React, { useEffect, useState } from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import headerHome from "../../assets/headerHome.png";
import SliderImg2 from "../../assets/Before After.png";
import NavbarContainer from '../Navbar/Navbar';
import "./Header.css";
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

function Header() {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  const [layout, setLayout] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const getAllApis = async () => {
      await axios
        .get(`https://nanosoft.technology/smile/api/sliders`)
        .then(async (res) => {
          console.log(res.data.data);

          setLayout(res.data.data);
          setLoading(false)

        })
        .catch((error) => {

          console.log(error.response.data);


        });




    }



    getAllApis()
  }, [])
  return (
    <div className='header_wrapper mb-5'>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}

        modules={[Autoplay]}
        className="mySwiper"
      >
        {layout.map((item, index) => (
          <SwiperSlide key={index}>
            <div
              className="header_slide"
              style={{ backgroundImage: `url(${item?.image})` }}
            >
              {item?.product &&
                <Link className="header_text_container " to={`product/${item?.product?.id}`}>
                  <div className="fw-bold px-3 py-1 rounded" style={{
                    backgroundColor: "#a1185c",
                    height: "42px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer"



                  }}>

                    <span className="mx-2">{currentLocal?.home?.seeOffer}</span>
                  </div>
                </Link>}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Header;
